<div style="padding: 2rem;">

  <!-- Page header -->
  <div style="margin-bottom: 1.75rem;">
    <h1 style="font-size: 1.5rem; font-weight: 700; color: #1e293b; margin: 0 0 0.25rem;">
      Pressing
    </h1>
    <p style="font-size: 0.875rem; color: #64748b; margin: 0;">Gestion du module pressing mobile</p>
  </div>

  <!-- Main card -->
  <div class="afri-card">

    <!-- Tabs -->
    <ul class="afri-tabs nav" style="padding: 0 1.5rem;">
      <li class="nav-item">
        <a role="tab" class="nav-link active" id="tab-c1-0" data-bs-toggle="tab" href="#tab-animated1-0" aria-selected="true">
          <span class="nav-text">Catégories</span>
        </a>
      </li>
      <li class="nav-item">
        <a role="tab" class="nav-link" id="tab-c1-1" data-bs-toggle="tab" href="#tab-animated1-1" aria-selected="false">
          <span class="nav-text">Pressings mobiles</span>
        </a>
      </li>
      <li class="nav-item">
        <a role="tab" class="nav-link" id="tab-c1-2" data-bs-toggle="tab" href="#tab-animated1-2" aria-selected="false">
          <span class="nav-text">Demandes</span>
        </a>
      </li>
    </ul>

    <div class="tab-content">

      <!-- Tab 1: Catégories -->
      <div class="tab-pane active" id="tab-animated1-0" role="tabpanel">

        <div class="afri-card-header">
          <div class="flex items-center gap-2 flex-wrap" *ngIf="buttonsPermission">
            <button *ngIf="buttonsPermission.add" (click)="add(addCategoryContent)" class="btn-afri-primary">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
              </svg>
              Ajouter
            </button>
            <button *ngIf="buttonsPermission.edit" (click)="edit(editCategoryContent)" class="btn-afri-outline" style="color: #d97706; border-color: #fcd34d;">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
              </svg>
              Éditer
            </button>
            <button *ngIf="buttonsPermission.delete" (click)="deleteCategory()" class="btn-afri-danger">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
              </svg>
              Supprimer
            </button>
          </div>
          <div class="flex items-center gap-2" style="font-size: 0.875rem; color: #64748b;">
            <span style="font-weight: 700; color: #1e293b; font-size: 1rem;">{{ data!.length }}</span>
            élément(s)
            <app-loading [isVisible]="loading2"></app-loading>
          </div>
        </div>

        <div style="overflow-x: auto;">
          <table class="afri-table">
            <thead>
              <tr>
                <th style="width: 52px; padding-left: 1.5rem;">#</th>
                <th>Nom</th>
                <th>Description</th>
                <th>Ajouté le</th>
                <th>Modifié le</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let d of data | paginate: {
                    id: 'ngxP1',
                    itemsPerPage: pg.pageSize,
                    currentPage: pg.p,
                    totalItems: pg.total
                  } | sampleSearch:search_text"
                  [style.background]="selected_data?.id === d.id ? '#f0f4ff' : ''">
                <td style="padding-left: 1.5rem;">
                  <input (click)="checked(d)" type="radio" name="selectRowCategory"
                         style="width: 16px; height: 16px; accent-color: #2E3190; cursor: pointer;">
                </td>
                <td>{{d.name}}</td>
                <td>{{d.description}}</td>
                <td>{{d.created_at | date:"dd/MM/yyyy"}}</td>
                <td>{{d.updated_at | date:"dd/MM/yyyy"}}</td>
              </tr>

              <tr *ngIf="data.length === 0 && !loading2">
                <td colspan="5" style="padding: 4rem 1.25rem; text-align: center;">
                  <div style="display: flex; flex-direction: column; align-items: center; gap: 0.75rem; color: #94a3b8;">
                    <svg class="w-12 h-12" style="color: #e2e8f0;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                    </svg>
                    <p style="margin: 0; font-weight: 500;">Aucune catégorie trouvée</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div style="padding: 0.5rem 1.5rem 1.25rem;">
          <pagination-controls
            id="ngxP1"
            (pageChange)="getPage1($event)"
            [maxSize]="9"
            [directionLinks]="true"
            [autoHide]="true"
            [responsive]="true"
            [previousLabel]="'Précédent'"
            [nextLabel]="'Suivant'">
          </pagination-controls>
        </div>

      </div><!-- end tab 1 -->

      <!-- Tab 2: Pressings mobiles -->
      <div class="tab-pane" id="tab-animated1-1" role="tabpanel">

        <div class="afri-card-header">
          <div class="flex items-center gap-2 flex-wrap" *ngIf="buttonsPermission2">
            <button *ngIf="buttonsPermission2.add" (click)="addPressingModal(addPressingContent)" class="btn-afri-primary">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
              </svg>
              Ajouter
            </button>
            <button *ngIf="buttonsPermission2.edit" (click)="editPressingModal(editPressingContent)" class="btn-afri-outline" style="color: #d97706; border-color: #fcd34d;">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
              </svg>
              Éditer
            </button>
            <button *ngIf="buttonsPermission2.delete" (click)="deletePressing()" class="btn-afri-danger">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
              </svg>
              Supprimer
            </button>
            <button *ngIf="buttonsPermission2.status && selected_pressing && !selected_pressing.available" (click)="togglePressingState(1)" [disabled]="loading" class="btn-afri-success">
              Rendre disponible <app-loading [isVisible]="loading"></app-loading>
            </button>
            <button *ngIf="buttonsPermission2.status && selected_pressing?.available" (click)="togglePressingState(0)" [disabled]="loading" class="btn-afri-danger">
              Rendre indisponible <app-loading [isVisible]="loading"></app-loading>
            </button>
          </div>
          <div class="flex items-center gap-2" style="font-size: 0.875rem; color: #64748b;">
            <span style="font-weight: 700; color: #1e293b; font-size: 1rem;">{{ dataPressings!.length }}</span>
            élément(s)
            <app-loading [isVisible]="loading2"></app-loading>
          </div>
        </div>

        <div style="overflow-x: auto;">
          <table class="afri-table">
            <thead>
              <tr>
                <th style="width: 52px; padding-left: 1.5rem;">#</th>
                <th>Nom</th>
                <th>Immatriculation</th>
                <th>Latitude</th>
                <th>Longitude</th>
                <th>Disponibilité</th>
                <th>Ajouté le</th>
                <th>Modifié le</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let d of dataPressings | paginate: {
                    id: 'ngxP2',
                    itemsPerPage: pg2.pageSize,
                    currentPage: pg2.p,
                    totalItems: pg2.total
                  } | sampleSearch:search_text2"
                  [style.background]="selected_pressing?.id === d.id ? '#f0f4ff' : ''">
                <td style="padding-left: 1.5rem;">
                  <input (click)="checkedPressing(d)" type="radio" name="selectRowPressing"
                         style="width: 16px; height: 16px; accent-color: #2E3190; cursor: pointer;">
                </td>
                <td>{{d.name}}</td>
                <td>{{d.plate_number}}</td>
                <td>{{d.latitude}}</td>
                <td>{{d.longitude}}</td>
                <td>
                  <span class="p-1 rounded text-white" [ngClass]="d.available ? 'bg-success' : 'bg-danger'">
                    {{ d.available ? 'Disponible' : 'Indisponible' }}
                  </span>
                </td>
                <td>{{d.created_at | date:"dd/MM/yyyy"}}</td>
                <td>{{d.updated_at | date:"dd/MM/yyyy"}}</td>
              </tr>

              <tr *ngIf="dataPressings.length === 0 && !loading2">
                <td colspan="8" style="padding: 4rem 1.25rem; text-align: center;">
                  <div style="display: flex; flex-direction: column; align-items: center; gap: 0.75rem; color: #94a3b8;">
                    <svg class="w-12 h-12" style="color: #e2e8f0;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                    </svg>
                    <p style="margin: 0; font-weight: 500;">Aucun pressing mobile trouvé</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div style="padding: 0.5rem 1.5rem 1.25rem;">
          <pagination-controls
            id="ngxP2"
            (pageChange)="getPage2($event)"
            [maxSize]="9"
            [directionLinks]="true"
            [autoHide]="true"
            [responsive]="true"
            [previousLabel]="'Précédent'"
            [nextLabel]="'Suivant'">
          </pagination-controls>
        </div>

      </div><!-- end tab 2 -->

      <!-- Tab 3: Demandes -->
      <div class="tab-pane" id="tab-animated1-2" role="tabpanel">

        <div class="afri-card-header">
          <div class="flex items-center gap-2 flex-wrap" *ngIf="buttonsPermission3">
            <button *ngIf="selected_appointment?.status === 'pending'" (click)="changeAppointmentStatus('accepted')" [disabled]="loading" class="btn-afri-success">
              Accepter <app-loading [isVisible]="loading"></app-loading>
            </button>
            <button *ngIf="selected_appointment?.status === 'accepted'" (click)="changeAppointmentStatus('in_progress')" [disabled]="loading" class="btn-afri-outline">
              Démarrer <app-loading [isVisible]="loading"></app-loading>
            </button>
            <button *ngIf="selected_appointment?.status === 'in_progress'" (click)="changeAppointmentStatus('completed')" [disabled]="loading" class="btn-afri-success">
              Marquer terminée <app-loading [isVisible]="loading"></app-loading>
            </button>
            <button *ngIf="selected_appointment && !['completed','cancelled'].includes(selected_appointment.status)" (click)="changeAppointmentStatus('cancelled')" [disabled]="loading" class="btn-afri-danger">
              Annuler <app-loading [isVisible]="loading"></app-loading>
            </button>
            <button *ngIf="buttonsPermission3.delete" (click)="deleteAppointment()" class="btn-afri-danger">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
              </svg>
              Supprimer
            </button>
          </div>
          <div class="flex items-center gap-2" style="font-size: 0.875rem; color: #64748b;">
            <span style="font-weight: 700; color: #1e293b; font-size: 1rem;">{{ dataAppointments!.length }}</span>
            élément(s)
            <app-loading [isVisible]="loading2"></app-loading>
          </div>
        </div>

        <div style="overflow-x: auto;">
          <table class="afri-table">
            <thead>
              <tr>
                <th style="width: 52px; padding-left: 1.5rem;">#</th>
                <th>Client</th>
                <th>Pressing</th>
                <th>Catégorie</th>
                <th>Adresse</th>
                <th>RDV le</th>
                <th>Prix</th>
                <th>Paiement</th>
                <th>Statut</th>
                <th>Demandé le</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let d of dataAppointments | paginate: {
                    id: 'ngxP3',
                    itemsPerPage: pg3.pageSize,
                    currentPage: pg3.p,
                    totalItems: pg3.total
                  } | sampleSearch:search_text3"
                  [style.background]="selected_appointment?.id === d.id ? '#f0f4ff' : ''">
                <td style="padding-left: 1.5rem;">
                  <input (click)="checkedAppointment(d)" type="radio" name="selectRowAppointment"
                         style="width: 16px; height: 16px; accent-color: #2E3190; cursor: pointer;">
                </td>
                <td>{{d.user?.lastname}} {{d.user?.firstname}}</td>
                <td>{{d.pressing?.name}}</td>
                <td>{{d.category?.name}}</td>
                <td>{{d.address}}</td>
                <td>{{d.appointment_time | date:"dd/MM/yyyy HH:mm"}}</td>
                <td>{{d.price}}</td>
                <td><app-status [value]="d.payment_status"></app-status></td>
                <td><app-status [value]="d.status"></app-status></td>
                <td>{{d.created_at | date:"dd/MM/yyyy"}}</td>
              </tr>

              <tr *ngIf="dataAppointments.length === 0 && !loading2">
                <td colspan="10" style="padding: 4rem 1.25rem; text-align: center;">
                  <div style="display: flex; flex-direction: column; align-items: center; gap: 0.75rem; color: #94a3b8;">
                    <svg class="w-12 h-12" style="color: #e2e8f0;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                    </svg>
                    <p style="margin: 0; font-weight: 500;">Aucune demande trouvée</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div style="padding: 0.5rem 1.5rem 1.25rem;">
          <pagination-controls
            id="ngxP3"
            (pageChange)="getPage3($event)"
            [maxSize]="9"
            [directionLinks]="true"
            [autoHide]="true"
            [responsive]="true"
            [previousLabel]="'Précédent'"
            [nextLabel]="'Suivant'">
          </pagination-controls>
        </div>

      </div><!-- end tab 3 -->

    </div><!-- end tab-content -->

  </div><!-- end card -->
</div>


<ng-template #addCategoryContent let-c="close" let-d="dismiss">
  <form #addForm="ngForm" (ngSubmit)="storeCategory(addForm.value)">
  <div class="modal-header">
    <h6 class="modal-title" id="modal-basic-title">Ajouter une catégorie de pressing</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
      <div class="row mb-3">
        <div class="col-12 mb-3">
          <label class="afri-label">Nom <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="name" class="afri-input" required ngModel>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Description</label>
          <textarea name="description" class="afri-input" rows="3" ngModel></textarea>
        </div>
      </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn-afri-primary" [disabled]="addForm.invalid">Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
  </div>
</form>
</ng-template>

<ng-template #editCategoryContent let-c="close" let-d="dismiss">
  <form #editForm="ngForm" (ngSubmit)="updateCategory(editForm.value)">
  <div class="modal-header">
    <h6 class="modal-title" id="modal-basic-title">Modifier une catégorie de pressing</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
      <div class="row mb-3">
        <div class="col-12 mb-3">
          <label class="afri-label">Nom <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="name" class="afri-input" required [(ngModel)]="selected_data.name">
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Description</label>
          <textarea name="description" class="afri-input" rows="3" [(ngModel)]="selected_data.description"></textarea>
        </div>
      </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn-afri-primary" [disabled]="editForm.invalid">Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
  </div>
</form>
</ng-template>

<ng-template #addPressingContent let-c="close" let-d="dismiss">
  <form #addPressingForm="ngForm" (ngSubmit)="storePressing(addPressingForm.value)">
  <div class="modal-header">
    <h6 class="modal-title" id="modal-basic-title">Ajouter un pressing mobile</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
      <div class="row mb-3">
        <div class="col-12 mb-3">
          <label class="afri-label">Nom <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="name" class="afri-input" required ngModel>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Immatriculation <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="plate_number" class="afri-input" required ngModel>
        </div>
        <div class="col-6 mb-3">
          <label class="afri-label">Latitude</label>
          <input type="number" step="any" name="latitude" class="afri-input" ngModel>
        </div>
        <div class="col-6 mb-3">
          <label class="afri-label">Longitude</label>
          <input type="number" step="any" name="longitude" class="afri-input" ngModel>
        </div>
      </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn-afri-primary" [disabled]="addPressingForm.invalid">Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
  </div>
</form>
</ng-template>

<ng-template #editPressingContent let-c="close" let-d="dismiss">
  <form #editPressingForm="ngForm" (ngSubmit)="updatePressing(editPressingForm.value)">
  <div class="modal-header">
    <h6 class="modal-title" id="modal-basic-title">Modifier un pressing mobile</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
      <div class="row mb-3">
        <div class="col-12 mb-3">
          <label class="afri-label">Nom <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="name" class="afri-input" required [(ngModel)]="selected_pressing.name">
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Immatriculation <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="plate_number" class="afri-input" required [(ngModel)]="selected_pressing.plate_number">
        </div>
        <div class="col-6 mb-3">
          <label class="afri-label">Latitude</label>
          <input type="number" step="any" name="latitude" class="afri-input" [(ngModel)]="selected_pressing.latitude">
        </div>
        <div class="col-6 mb-3">
          <label class="afri-label">Longitude</label>
          <input type="number" step="any" name="longitude" class="afri-input" [(ngModel)]="selected_pressing.longitude">
        </div>
      </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn-afri-primary" [disabled]="editPressingForm.invalid">Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
  </div>
</form>
</ng-template>
